// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"e985f47b","977":"7a1d82fb"}[chunkId] + ".chunk.js";
};